export const PARTNER_LOGOS = {
  arkansas: {
    src: '/images/city_explorer_logos/ar_flag.webp',
    alt: 'Arkansas',
    name: 'Analysis Homepage',
  },
  connecticut: {
    src: '/images/city_explorer_logos/mind_trust_ct_logo.jpeg',
    alt: 'Mind Trust Connecticut',
    name: 'Mind Trust Connecticut',
  },
  new_mexico: {
    src: '/images/city_explorer_logos/esnm_logo.png',
    alt: 'Excellent Schools New Mexico',
    name: 'Excellent Schools New Mexico',
  },
  newark: {
    src: '/images/city_explorer_logos/njcf_logo.jpeg',
    alt: "New Jersey Children's Foundation",
    name: "New Jersey Children's Foundation",
  },
  washington: {
    src: '/images/city_explorer_logos/esw_logo.webp',
    alt: 'Excellent Schools Washington',
    name: 'Excellent Schools Washington',
  },
};

export const partnerLogoFor = (locationId) => PARTNER_LOGOS[locationId] || null;

export const partnerOrgName = (location) => {
  const fromDoc = String(location?.partnerOrg || '').trim();
  if (fromDoc) return fromDoc;
  return partnerLogoFor(location?.id)?.name || '';
};
